import {OperatorType} from './enums/OperatorType';
import {IOperator} from './Operator';

// operator
export const DEFAULT_OPERATOR_AVATAR: string = "https://cdn.iconscout.com/icon/free/png-256/operator-1411794-1194283.png";
export const DEFAULT_OPERATOR_AVATAR_ID: string | null= null;

export const DEFAULT_CONTACT_AVATAR: string = "src/app/shared/images/support.png";